import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './Faq.scss';

function FAQItem({ question, answer, isOpen, onClick }) {
    return (
        <div className={`faq-item ${isOpen ? 'active' : ''}`}>
            <button
                className="faq-question"
                onClick={onClick}
                aria-expanded={isOpen}
                type="button"
            >
                <span>{question}</span>

                <span className="faq-icon">
                    <span></span>
                    <span></span>
                </span>
            </button>

            <div
                className="faq-answer-wrapper"
                style={{
                    maxHeight: isOpen ? '1000px' : '0px',
                }}
            >
                <div className="faq-answer">
                    {answer}
                </div>
            </div>
        </div>
    );
}

export default function FAQ() {
    const { t } = useTranslation();

    const [openItem, setOpenItem] = useState(null);

    const handleToggle = (id) => {
        setOpenItem((current) => (current === id ? null : id));
    };

    const allFaqs = Array.from({ length: 18 }, (_, index) => ({
        question: t(`faq.items.${index}.question`),
        answer: (
            <p>
                {t(`faq.items.${index}.answer`)}
            </p>
        ),
    }));

    /*
     * DESKTOP
     * 3 Spalten
     */
    const desktopColumns = [
        allFaqs.slice(0, 6),
        allFaqs.slice(6, 12),
        allFaqs.slice(12, 18),
    ];

    /*
     * TABLET / IPAD
     * 2 Spalten
     */
    const tabletColumns = [
        allFaqs.slice(0, Math.ceil(allFaqs.length / 2)),
        allFaqs.slice(Math.ceil(allFaqs.length / 2)),
    ];

    /*
     * MOBILE
     * 1 Spalte
     */
    const mobileColumns = [allFaqs];

    return (
        <section className="faq-section">

            <div className="faq-header">
                <h1>{t('faq.title')}</h1>

                <p>
                    {t('faq.description')}
                </p>
            </div>

            {/* DESKTOP */}
            <div className="faq-grid faq-grid-desktop">
                {desktopColumns.map((column, columnIndex) => (
                    <div className="faq-column" key={columnIndex}>
                        {column.map((item, itemIndex) => {
                            const id = `desktop-${columnIndex}-${itemIndex}`;

                            return (
                                <FAQItem
                                    key={id}
                                    question={item.question}
                                    answer={item.answer}
                                    isOpen={openItem === id}
                                    onClick={() => handleToggle(id)}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>

            {/* IPAD / TABLET */}
            <div className="faq-grid faq-grid-tablet">
                {tabletColumns.map((column, columnIndex) => (
                    <div className="faq-column" key={columnIndex}>
                        {column.map((item, itemIndex) => {
                            const id = `tablet-${columnIndex}-${itemIndex}`;

                            return (
                                <FAQItem
                                    key={id}
                                    question={item.question}
                                    answer={item.answer}
                                    isOpen={openItem === id}
                                    onClick={() => handleToggle(id)}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>

            {/* MOBILE */}
            <div className="faq-grid faq-grid-mobile">
                {mobileColumns.map((column, columnIndex) => (
                    <div className="faq-column" key={columnIndex}>
                        {column.map((item, itemIndex) => {
                            const id = `mobile-${itemIndex}`;

                            return (
                                <FAQItem
                                    key={id}
                                    question={item.question}
                                    answer={item.answer}
                                    isOpen={openItem === id}
                                    onClick={() => handleToggle(id)}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>

        </section>
    );
}